import "core-js/modules/es.array.map.js";
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-738b7fd0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["data-idx", "onClick"];
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  key: 0,
  "class": "lg:tw-flex lg:tw-flex-col lg:tw-items-center lg:tw-justify-center lg:tw-h-full tw-bg-w-lavender"
};
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  "class": "tw-flex tw-flex-row tw-justify-center tw-bg-white tw-mb-10px"
};
var _hoisted_7 = {
  "class": "tw-bg-white tw-flex tw-flex-row tw-justify-between tw-rounded tw-p-10px tw-shadow -tw-mt-20px tw-z-10"
};
var _hoisted_8 = {
  "class": "tw-text-w-black tw-hidden sm:tw-block"
};
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = ["innerHTML"];
var _hoisted_15 = {
  key: 0,
  "class": "tw-flex tw-flex-col tw-bg-white tw-fixed tw-w-full tw-h-full tw-max-w-[100vw] tw-max-h-[100vh] tw-top-0 tw-left-0 tw-z-[1052]"
};
var _hoisted_16 = {
  "class": "tw-flex md:tw-hidden tw-flex-row-reverse md:tw-flex-row tw-items-center tw-justify-between tw-w-full tw-px-15px tw-py-20px tw-shadow-[0_.125rem_.25rem_rgba(27,27,27,.075)]"
};
var _hoisted_17 = {
  "class": "tw-flex"
};
var _hoisted_18 = ["data-url"];
var _hoisted_19 = {
  "class": "tw-hidden md:tw-flex tw-items-center tw-justify-between tw-p-25px"
};
var _hoisted_20 = {
  "class": "tw-text tw-font-regular tw-block tw-mb-10px"
};
var _hoisted_21 = {
  "class": "tw-flex tw-items-center"
};
var _hoisted_22 = ["innerHTML"];
var _hoisted_23 = {
  key: 1,
  "class": "tw-flex tw-items-center tw-mr-20px"
};
var _hoisted_24 = {
  "class": "tw-bg-w-cultured tw-p-5px tw-rounded-[5px] tw-mr-5px"
};
var _hoisted_25 = {
  "class": "tw-font-semibold"
};
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "tw-text-12"
  }, [/*#__PURE__*/_createTextVNode("m"), /*#__PURE__*/_createElementVNode("sup", null, "2")], -1 /* HOISTED */);
});
var _hoisted_27 = {
  key: 2,
  "class": "tw-flex tw-items-center tw-mr-20px"
};
var _hoisted_28 = {
  "class": "tw-bg-w-cultured tw-p-5px tw-rounded-[5px] tw-mr-5px"
};
var _hoisted_29 = {
  "class": "tw-font-semibold"
};
var _hoisted_30 = ["innerHTML"];
var _hoisted_31 = ["innerHTML"];
var _hoisted_32 = {
  key: 3,
  "class": "tw-flex tw-items-center tw-mr-20px"
};
var _hoisted_33 = {
  "class": "tw-bg-w-cultured tw-p-5px tw-rounded-[5px] tw-mr-5px"
};
var _hoisted_34 = {
  "class": "tw-font-semibold"
};
var _hoisted_35 = ["innerHTML"];
var _hoisted_36 = ["innerHTML"];
var _hoisted_37 = {
  "class": "tw-flex tw-items-center"
};
var _hoisted_38 = ["innerHTML"];
var _hoisted_39 = ["innerHTML"];
var _hoisted_40 = ["innerHTML"];
var _hoisted_41 = {
  "class": "tw-h-full lg:tw-h-[calc(100%_-_170px)] lg:tw-pb-20px"
};
var _hoisted_42 = {
  key: 0,
  "class": "tw-h-full"
};
var _hoisted_43 = ["src"];
var _hoisted_44 = ["src"];
var _hoisted_45 = ["src"];
var _hoisted_46 = {
  key: 4,
  "class": "tw-h-full tw-w-full"
};
var _hoisted_47 = ["innerHTML"];
var _hoisted_48 = ["src"];
var _hoisted_49 = {
  "class": "tw-flex tw-items-center tw-flex-col tw-shadow-[0_1rem_3rem_rgba(27,27,27,.175)]"
};
var _hoisted_50 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("hr", {
    "class": "tw-bg-w-cultured tw-h-[1px] tw-w-11/12 tw-m-0 tw-mb-10px tw-opacity-25 tw-hidden sm:tw-block"
  }, null, -1 /* HOISTED */);
});
var _hoisted_51 = {
  "class": "tw-flex tw-items-center tw-py-10px"
};
var _hoisted_52 = ["innerHTML"];
var _hoisted_53 = ["innerHTML"];
var _hoisted_54 = ["innerHTML"];
var _hoisted_55 = ["innerHTML"];
var _hoisted_56 = ["innerHTML"];
var _hoisted_57 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_swiper_carousel = _resolveComponent("swiper-carousel");
  var _component_photo_icon = _resolveComponent("photo-icon");
  var _component_base_icon = _resolveComponent("base-icon");
  var _component_plan_icon = _resolveComponent("plan-icon");
  var _component_streetview_icon = _resolveComponent("streetview-icon");
  var _component_video_icon = _resolveComponent("video-icon");
  var _component_tour_icon = _resolveComponent("tour-icon");
  var _component_map_icon = _resolveComponent("map-icon");
  var _component_heart_icon = _resolveComponent("heart-icon");
  var _component_base_button = _resolveComponent("base-button");
  var _component_share_icon = _resolveComponent("share-icon");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createCommentVNode(" CAROUSEL IN-PAGE "), _createElementVNode("div", {
    ref: "root",
    "class": _normalizeClass(["gallery tw-flex lg:tw-rounded tw-overflow-hidden [-webkit-mask-image:-webkit-radial-gradient(white,black)]", _ctx.galleryClasses])
  }, [_createVNode(_component_swiper_carousel, {
    id: "details-carousel",
    ref: "detailsCarousel",
    "data-cy": "details-carousel",
    "root-classes": "tw-w-full tw-bg-w-lavender lg:tw-w-1/2",
    "swiper-classes": "tw-h-full",
    "slide-img-classes": "tw-h-full tw-w-full !tw-object-cover",
    images: _ctx.images.length ? _ctx.transformReImages(_ctx.images, [_ctx.IMAGE_FORMATS.SMALL, _ctx.IMAGE_FORMATS.MEDIUM, _ctx.IMAGE_FORMATS.SMALL]) : _ctx.transformReImages(_ctx.planimetries, [_ctx.IMAGE_FORMATS.SMALL, _ctx.IMAGE_FORMATS.MEDIUM, _ctx.IMAGE_FORMATS.SMALL]),
    "art-direction": {
      sm: {
        mq: '(max-width: 575px)',
        width: '320w'
      },
      md: {
        mq: '(min-width: 576px) and (max-width: 1199px)',
        width: '640w'
      },
      lg: {
        mq: '',
        width: '1280w'
      }
    },
    "swiper-options": {
      slidesPerView: 1,
      initialSlide: _ctx.currentImage,
      navigation: true,
      lazyPreloadPrevNext: 1
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.openFullscreen();
    }),
    onMoved: _cache[1] || (_cache[1] = function (_ref) {
      var activeIndex = _ref.activeIndex;
      return _ctx.currentImage = activeIndex;
    })
  }, null, 8 /* PROPS */, ["images", "swiper-options"]), _createElementVNode("div", {
    "class": "tw-flex-wrap tw-h-full lg:tw-w-1/2 tw-px-0 tw-hidden lg:tw-flex tw-cursor-pointer",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return _ctx.openFullscreen(false);
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstFourImages, function (image, idx) {
    var _a;
    return _openBlock(), _createElementBlock("div", {
      key: "gallery_desktop_img_".concat(idx),
      "class": _normalizeClass(["tw-pl-10px tw-w-1/2", [{
        'tw-mb-10px': idx < 2
      }, {
        'tw-h-full': _ctx.firstFourImages.length === 1
      }, {
        'tw-h-1/2': _ctx.firstFourImages.length > 1
      }]]),
      "data-idx": "".concat(idx),
      onClick: function onClick($event) {
        return _ctx.goToSlide(idx + 1);
      }
    }, [image.images ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      "class": "tw-h-full tw-w-full tw-object-cover tw-bg-w-lavender",
      fetchpriority: "low",
      src: (_a = _ctx.getImageFormat(image, _ctx.IMAGE_FORMATS.SMALL)) === null || _a === void 0 ? void 0 : _a.storagePath,
      alt: "",
      width: "200",
      height: "150"
    }, null, 8 /* PROPS */, _hoisted_2)) : _createCommentVNode("v-if", true)], 10 /* CLASS, PROPS */, _hoisted_1);
  }), 128 /* KEYED_FRAGMENT */)), _createCommentVNode(" More photos section "), _ctx.firstFourImages.length < 5 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": _normalizeClass(["tw-hidden lg:tw-block", [{
      'tw-pl-10px': _ctx.firstFourImages.length === 0 || _ctx.firstFourImages.length === 2,
      'tw-pl-5px': _ctx.firstFourImages.length === 1 || _ctx.firstFourImages.length === 3
    }, {
      'tw-h-full': _ctx.firstFourImages.length < 2,
      'tw-h-1/2': _ctx.firstFourImages.length >= 2
    }, {
      'tw-w-1/2': _ctx.firstFourImages.length === 1 || _ctx.firstFourImages.length === 3,
      'tw-w-full': _ctx.firstFourImages.length === 0 || _ctx.firstFourImages.length === 2
    }]]),
    onClick: _cache[3] || (_cache[3] = _withModifiers(function () {}, ["stop"]))
  }, [_createCommentVNode(" Div needed in order to have a little white space between cols/rows "), !_ctx.isAuction ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_photo_icon, {
    width: 40,
    height: 60,
    "stroke-color": "#fff"
  }), _createElementVNode("p", {
    "class": "tw-text-white tw-mb-10px tw-text-center",
    innerHTML: _ctx.labels.wantMorePhotos
  }, null, 8 /* PROPS */, _hoisted_4)])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    "class": "lg:tw-flex lg:tw-flex-col lg:tw-items-center lg:tw-justify-center lg:tw-h-full tw-bg-w-lavender",
    onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
      return _ctx.$emit('open-request-attachments-modal');
    }, ["stop"]))
  }, [_createVNode(_component_base_icon, {
    "class": "tw-inline-block tw-mb-5px",
    "icon-type": "icon-xxl",
    "alt-attribute": "icona informazioni",
    "icon-name": "info-dark-primary-full.svg"
  }), _createElementVNode("p", {
    "class": "tw-text-w-dark-primary tw-mb-10px tw-text-center",
    innerHTML: _ctx.labels.wantMorePhotoAuction
  }, null, 8 /* PROPS */, _hoisted_5)]))], 2 /* CLASS */)) : _createCommentVNode("v-if", true)])], 2 /* CLASS */), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_ctx.images.length ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    "data-cy": "gallery-images-button",
    "class": "images-button tw-flex tw-items-center tw-text-12 tw-px-10px tw-bg-transparent",
    onClick: _cache[5] || (_cache[5] = _withModifiers(function ($event) {
      return _ctx.openFullscreen(false);
    }, ["stop"]))
  }, [_createVNode(_component_photo_icon, {
    "stroke-width": "1",
    width: 20,
    height: 20,
    "class": "tw-mr-5px"
  }), _createElementVNode("span", _hoisted_8, [_createTextVNode(_toDisplayString(_ctx.images.length) + " ", 1 /* TEXT */), _createElementVNode("span", {
    innerHTML: _ctx.labels.photo
  }, null, 8 /* PROPS */, _hoisted_9)])])) : _createCommentVNode("v-if", true), _ctx.planimetries.length ? (_openBlock(), _createElementBlock("button", {
    key: 1,
    "data-cy": "gallery-planimetries-button",
    "class": _normalizeClass(["images-button tw-flex tw-items-center tw-text-12 tw-px-10px tw-bg-transparent", _ctx.images.length && 'tw-border-l tw-border-secondary [border-left-style:solid]']),
    onClick: _cache[6] || (_cache[6] = _withModifiers(function ($event) {
      return _ctx.openPlanimetries(false);
    }, ["stop"]))
  }, [_createVNode(_component_plan_icon, {
    width: 18,
    height: 18,
    "stroke-width": "0.8",
    "class": "tw-mr-5px"
  }), _createElementVNode("span", {
    "class": "tw-text-w-black tw-hidden sm:tw-block",
    innerHTML: _ctx.labels.planimetry
  }, null, 8 /* PROPS */, _hoisted_10)], 2 /* CLASS */)) : _createCommentVNode("v-if", true), _ctx.streetView ? (_openBlock(), _createElementBlock("button", {
    key: 2,
    "data-cy": "gallery-map-button",
    "class": "images-button tw-flex tw-items-center tw-text-12 tw-px-10px tw-border-l tw-border-secondary [border-left-style:solid] tw-bg-transparent",
    onClick: _cache[7] || (_cache[7] = _withModifiers(function ($event) {
      return _ctx.openStreetView(false);
    }, ["stop"]))
  }, [_createVNode(_component_streetview_icon, {
    width: 20,
    height: 20,
    "class": "tw-mr-5px",
    "stroke-width": "0.8"
  }), _createElementVNode("span", {
    "class": "tw-text-w-black tw-hidden sm:tw-block",
    innerHTML: _ctx.labels.streetview
  }, null, 8 /* PROPS */, _hoisted_11)])) : _createCommentVNode("v-if", true), _ctx.videoUrl ? (_openBlock(), _createElementBlock("button", {
    key: 3,
    "data-cy": "gallery-video-button",
    "class": "images-button tw-flex tw-items-center tw-text-12 tw-px-10px tw-border-l tw-border-secondary [border-left-style:solid] tw-bg-transparent",
    onClick: _cache[8] || (_cache[8] = _withModifiers(function ($event) {
      return _ctx.openVideo(false);
    }, ["stop"]))
  }, [_createVNode(_component_video_icon, {
    width: 20,
    height: 20,
    "class": "tw-mr-5px"
  }), _createElementVNode("span", {
    "class": "tw-text-w-black tw-hidden sm:tw-block",
    innerHTML: _ctx.labels.video
  }, null, 8 /* PROPS */, _hoisted_12)])) : _createCommentVNode("v-if", true), _ctx.tourUrl ? (_openBlock(), _createElementBlock("button", {
    key: 4,
    "data-cy": "gallery-tour-button",
    "class": "images-button tw-flex tw-items-center tw-text-12 tw-px-10px tw-border-l tw-border-secondary [border-left-style:solid] tw-bg-transparent",
    onClick: _cache[9] || (_cache[9] = _withModifiers(function ($event) {
      return _ctx.openTour(false);
    }, ["stop"]))
  }, [_createVNode(_component_tour_icon, {
    "class": "tw-mr-5px",
    height: 20,
    width: 20
  }), _createElementVNode("span", {
    "class": "tw-text-w-black tw-hidden sm:tw-block",
    innerHTML: _ctx.labels.tour
  }, null, 8 /* PROPS */, _hoisted_13)])) : _createCommentVNode("v-if", true), _ctx.mapUrl ? (_openBlock(), _createElementBlock("button", {
    key: 5,
    "data-cy": "gallery-map-button",
    "class": "images-button tw-flex tw-items-center tw-text-12 tw-px-10px tw-border-l tw-border-secondary [border-left-style:solid] tw-bg-transparent",
    onClick: _cache[10] || (_cache[10] = _withModifiers(function ($event) {
      return _ctx.openMap(false);
    }, ["stop"]))
  }, [_createVNode(_component_map_icon, {
    width: 20,
    height: 20,
    "class": "tw-mr-5px",
    "stroke-width": "0.8"
  }), _createElementVNode("span", {
    "class": "tw-text-w-black tw-hidden sm:tw-block",
    innerHTML: _ctx.labels.map
  }, null, 8 /* PROPS */, _hoisted_14)])) : _createCommentVNode("v-if", true)])]), _createCommentVNode(" CAROUSEL FULLSCREEN "), _ctx.realEstate && (_ctx.planimetriesFullscreen || _ctx.fullscreen || _ctx.videoFullscreen || _ctx.tourFullscreen || _ctx.mapFullscreen || _ctx.streetViewFullscreen) ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createCommentVNode(" HEADER "), _createCommentVNode(" Top mobile navbar: favorite, share and close buttons "), _createElementVNode("div", _hoisted_16, [_createCommentVNode(" Favorite and Share buttons "), _createElementVNode("div", _hoisted_17, [_createCommentVNode(" Favorite button "), _createElementVNode("button", {
    id: "gallery-fav-save",
    "class": "tw-cursor-pointer tw-pr-15px tw-bg-transparent",
    onClick: _cache[11] || (_cache[11] = _withModifiers(function ($event) {
      return _ctx.onFavBtnClick(_ctx.realEstate.id);
    }, ["stop"]))
  }, [_createVNode(_component_heart_icon, _mergeProps({
    width: 24,
    height: 24,
    "class": "tw-mr-5px tw-inline-block"
  }, _ctx.setFavoritesIcon()), null, 16 /* FULL_PROPS */)]), _createCommentVNode(" Share button "), _createElementVNode("button", {
    "class": "share tw-cursor-pointer tw-bg-transparent",
    "data-url": _ctx.shareUrl,
    onClick: _cache[12] || (_cache[12] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.openShareModal && _ctx.openShareModal.apply(_ctx, arguments);
    }, ["prevent", "stop"]))
  }, [_createVNode(_component_base_icon, {
    "class": "tw-inline-block",
    "icon-type": "icon-lg",
    "alt-attribute": "icona inactive",
    "icon-name": "share-blue.svg"
  })], 8 /* PROPS */, _hoisted_18)]), _createCommentVNode(" Close Button "), _createElementVNode("button", {
    "class": "tw-bg-transparent",
    onClick: _cache[13] || (_cache[13] = function ($event) {
      return _ctx.closeFullscreen(false);
    })
  }, [_createVNode(_component_base_icon, {
    id: "close-fullscreen",
    "class": "tw-cursor-pointer",
    "alt-attribute": "icona chiudi",
    "icon-name": "close.svg"
  })])]), _createCommentVNode(" Top mobile desktop: favorite, share and close buttons "), _createElementVNode("div", _hoisted_19, [_createCommentVNode(" Desktop: real estate title and details "), _createElementVNode("div", null, [_createCommentVNode(" -Desktop: real estate title "), _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.title), 1 /* TEXT */), _createElementVNode("div", _hoisted_21, [_createCommentVNode(" Desktop: real estate price "), _ctx.displayPrice ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    "class": "tw-font-semibold tw-text tw-mr-15px",
    innerHTML: _ctx.displayPrice
  }, null, 8 /* PROPS */, _hoisted_22)) : _createCommentVNode("v-if", true), _createCommentVNode(" Desktop: real estate features "), _ctx.realEstate && _ctx.realEstate.sqM > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_base_icon, {
    "alt-attribute": "icona metri quadrati",
    "class": "icon-sm",
    "icon-name": "square-meter.svg",
    "icon-class": ""
  })]), _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.realEstate.sqM), 1 /* TEXT */), _createTextVNode("  "), _hoisted_26])) : _createCommentVNode("v-if", true), _ctx.realEstate && _ctx.realEstate.rooms > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(_component_base_icon, {
    "alt-attribute": "icona locali",
    "class": "icon-sm",
    "icon-name": "rooms.svg",
    "icon-class": ""
  })]), _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.realEstate.rooms), 1 /* TEXT */), _createTextVNode("  "), _ctx.realEstate.rooms == 1 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    "class": "tw-text-12",
    innerHTML: _ctx.labels.room
  }, null, 8 /* PROPS */, _hoisted_30)) : (_openBlock(), _createElementBlock("span", {
    key: 1,
    "class": "tw-text-12",
    innerHTML: _ctx.labels.rooms
  }, null, 8 /* PROPS */, _hoisted_31))])) : _createCommentVNode("v-if", true), _ctx.realEstate.bathrooms > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_base_icon, {
    "alt-attribute": "bath icon",
    "class": "icon-sm",
    "icon-name": "bath.svg",
    "icon-class": ""
  })]), _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.realEstate.bathrooms), 1 /* TEXT */), _createTextVNode("  "), _ctx.realEstate.bathrooms == 1 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    "class": "tw-text-12",
    innerHTML: _ctx.labels.bathroom
  }, null, 8 /* PROPS */, _hoisted_35)) : (_openBlock(), _createElementBlock("span", {
    key: 1,
    "class": "tw-text-12",
    innerHTML: _ctx.labels.bathrooms
  }, null, 8 /* PROPS */, _hoisted_36))])) : _createCommentVNode("v-if", true)])]), _createElementVNode("div", _hoisted_37, [_createCommentVNode(" Desktop: favorite button "), _createVNode(_component_base_button, {
    "class": "tw-mr-20px",
    "btn-class": "tw-btn-w-primary tw-btn-outline tw-btn-sm",
    onClick: _cache[14] || (_cache[14] = _withModifiers(function ($event) {
      return _ctx.isREInFavorites ? _ctx.handleRemoveFavorite(_ctx.realEstate.id) : _ctx.handleAddFavorite(_ctx.realEstate.id);
    }, ["prevent", "stop"]))
  }, {
    "default": _withCtx(function (_ref2) {
      var hover = _ref2.hover;
      return [_createVNode(_component_heart_icon, _mergeProps({
        width: 16,
        height: 16,
        "class": "tw-mr-5px tw-inline-block"
      }, _ctx.setFavoritesIcon(hover)), null, 16 /* FULL_PROPS */), _ctx.isREInFavorites ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        "class": "tw-inline-block tw-font-semibold tw-ml-5px",
        innerHTML: _ctx.labels.remove
      }, null, 8 /* PROPS */, _hoisted_38)) : (_openBlock(), _createElementBlock("span", {
        key: 1,
        "class": "tw-inline-block tw-font-semibold tw-ml-5px",
        innerHTML: _ctx.labels.save
      }, null, 8 /* PROPS */, _hoisted_39))];
    }),
    _: 1 /* STABLE */
  }), _createVNode(_component_base_button, {
    "btn-class": "tw-btn-w-primary tw-btn-outline tw-btn-sm",
    "data-url": _ctx.shareUrl,
    onClick: _withModifiers(_ctx.openShareModal, ["stop"])
  }, {
    "default": _withCtx(function (_ref3) {
      var hover = _ref3.hover;
      return [_createVNode(_component_share_icon, {
        width: 16,
        height: 16,
        "stroke-color": hover ? '#fff' : '#2b5dff',
        "class": "tw-mr-5px tw-inline-block"
      }, null, 8 /* PROPS */, ["stroke-color"]), _createElementVNode("span", {
        "class": "tw-inline-block tw-font-semibold tw-ml-5px",
        innerHTML: _ctx.labels.share
      }, null, 8 /* PROPS */, _hoisted_40)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["data-url", "onClick"]), _createCommentVNode(" Close Button "), _createElementVNode("button", {
    "class": "tw-bg-transparent",
    onClick: _cache[15] || (_cache[15] = function ($event) {
      return _ctx.closeFullscreen(false);
    })
  }, [_createVNode(_component_base_icon, {
    id: "close-fullscreen-desktop",
    "class": "tw-inline-block tw-cursor-pointer tw-ml-20px",
    "alt-attribute": "icona chiudi",
    "icon-name": "close.svg"
  })])])]), _createCommentVNode(" CONTENUTO "), _createElementVNode("div", _hoisted_41, [_ctx.showFullscreenGallery ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_ctx.parsedImages.length ? _withDirectives((_openBlock(), _createBlock(_component_swiper_carousel, {
    key: 0,
    id: "fullscreen-re-carousel",
    "data-cy": "fullscreen-re-carousel",
    images: _ctx.parsedImages,
    "root-classes": "tw-h-full tw-relative",
    "swiper-classes": "tw-h-3/4 lg:tw-h-full",
    "swiper-pagination-classes": "[--swiper-pagination-bottom:0px] lg:[--swiper-pagination-bottom:10px]",
    "slide-img-classes": "tw-h-full tw-w-auto tw-rounded-none md:tw-rounded tw-max-h-[600px]",
    "thumb-img-classes": "!tw-object-cover",
    "thumb-img-wrapper-classes": "!tw-flex tw-justify-center tw-items-center",
    "art-direction": {
      sm: {
        mq: '(max-width: 575px)',
        width: '640w'
      },
      lg: {
        mq: '',
        width: '1280w'
      }
    },
    "swiper-options": {
      effect: 'none',
      lazyPreloadPrevNext: 1,
      initialSlide: _ctx.currentImage,
      slidesPerView: 1,
      zoom: {
        maxRatio: 2
      },
      keyboard: {
        enabled: true
      },
      navigation: true,
      pagination: {
        type: 'fraction'
      },
      breakpoints: {
        320: {
          navigation: {
            enabled: false
          }
        },
        992: {
          navigation: {
            enabled: true
          }
        }
      }
    },
    "thumb-swiper-options": {
      lazyPreloadPrevNext: 1,
      slidesPerView: _ctx.images.length < 4 ? _ctx.images.length : 4,
      watchSlidesProgress: true,
      freeMode: true
    },
    onMoved: _cache[16] || (_cache[16] = function (_ref4) {
      var activeIndex = _ref4.activeIndex;
      return _ctx.currentImage = activeIndex;
    })
  }, null, 8 /* PROPS */, ["images", "swiper-options", "thumb-swiper-options"])), [[_vShow, _ctx.fullscreen]]) : _createCommentVNode("v-if", true), _withDirectives(_createVNode(_component_swiper_carousel, {
    id: "fullscreen-planimetries",
    "data-cy": "fullscreen-planimetries",
    images: _ctx.parsedPlanimetries,
    "root-classes": "tw-h-full tw-relative",
    "swiper-classes": "tw-h-3/4 lg:tw-h-full",
    "slide-img-classes": "tw-h-full tw-w-auto tw-rounded-none md:tw-rounded tw-max-h-[600px]",
    "swiper-pagination-classes": "[--swiper-pagination-bottom:0px] lg:[--swiper-pagination-bottom:10px]",
    "thumb-img-classes": "!tw-object-cover",
    "thumb-img-wrapper-classes": "!tw-flex tw-justify-center tw-items-center",
    "art-direction": {
      sm: {
        mq: '(max-width: 575px)',
        width: '640w'
      },
      lg: {
        mq: '',
        width: '1280w'
      }
    },
    "swiper-options": {
      keyboard: {
        enabled: true
      },
      initialSlide: _ctx.currentPlanimetry,
      lazyPreloadPrevNext: 1,
      slidesPerView: 1,
      zoom: {
        maxRatio: 1
      },
      navigation: true,
      pagination: {
        type: 'fraction'
      },
      breakpoints: {
        320: {
          navigation: {
            enabled: false
          }
        },
        992: {
          navigation: {
            enabled: true
          }
        }
      }
    },
    "thumb-swiper-options": {
      slidesPerView: _ctx.planimetries.length < 4 ? _ctx.planimetries.length : 4,
      watchSlidesProgress: true,
      freeMode: true
    },
    onMoved: _cache[17] || (_cache[17] = function (_ref5) {
      var activeIndex = _ref5.activeIndex;
      return _ctx.currentPlanimetry = activeIndex;
    })
  }, null, 8 /* PROPS */, ["images", "swiper-options", "thumb-swiper-options"]), [[_vShow, _ctx.planimetriesFullscreen]])])) : _createCommentVNode("v-if", true), _createCommentVNode("streetview"), _ctx.streetViewFullscreen ? (_openBlock(), _createElementBlock("iframe", {
    key: 1,
    ref: "streetViewFull",
    allowfullscreen: "",
    "class": "tw-h-full tw-w-full",
    src: _ctx.streetView,
    style: {
      "border": "0"
    }
  }, null, 8 /* PROPS */, _hoisted_43)) : _createCommentVNode("v-if", true), _createCommentVNode("VIDEO"), _ctx.videoFullscreen ? (_openBlock(), _createElementBlock("iframe", {
    key: 2,
    ref: "videoFull",
    src: _ctx.videoUrl,
    frameborder: "0",
    "class": "tw-h-full tw-w-full"
  }, null, 8 /* PROPS */, _hoisted_44)) : _createCommentVNode("v-if", true), _createCommentVNode("TOUR"), _ctx.tourFullscreen ? (_openBlock(), _createElementBlock("iframe", {
    key: 3,
    ref: "tourFull",
    allowfullscreen: "",
    defaultTarget: "true",
    "class": "tw-h-full tw-w-full",
    src: _ctx.tourUrl,
    style: {
      "border": "0"
    }
  }, null, 8 /* PROPS */, _hoisted_45)) : _createCommentVNode("v-if", true), _createCommentVNode("MAPPA"), _ctx.mapFullscreen ? (_openBlock(), _createElementBlock("div", _hoisted_46, [!_ctx.realEstate.publishMap ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    "class": "tw-py-5px tw-px-10px tw-mb-0",
    innerHTML: _ctx.labels.aproximatePosition
  }, null, 8 /* PROPS */, _hoisted_47)) : _createCommentVNode("v-if", true), _ctx.mapFullscreen ? (_openBlock(), _createElementBlock("iframe", {
    key: 1,
    ref: "mapFull",
    allowfullscreen: "",
    "class": _normalizeClass(["tw-h-full tw-w-full", {
      'pb-with-disclaimer tw-pb-12 sm:tw-pb-7': !_ctx.realEstate.publishMap
    }]),
    style: {
      "border": "0"
    },
    src: _ctx.mapUrl
  }, null, 10 /* CLASS, PROPS */, _hoisted_48)) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true)]), _createCommentVNode(" FOOTER "), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createCommentVNode("NAVS"), _createElementVNode("div", _hoisted_51, [_ctx.images.length ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    ref: "galleryPhotoBtn",
    "class": _normalizeClass(["modal-button tw-flex tw-items-center tw-text-10 tw-mb-5px tw-px-5px tw-mr-20px tw-justify-center tw-relative tw-pb-10px tw-bg-transparent", {
      'active': _ctx.fullscreen
    }]),
    onClick: _cache[18] || (_cache[18] = _withModifiers(function ($event) {
      return _ctx.openFullscreen(false);
    }, ["stop"]))
  }, [_createVNode(_component_photo_icon, {
    "stroke-width": _ctx.fullscreen ? '1.5' : '1.2',
    width: 24,
    height: 24
  }, null, 8 /* PROPS */, ["stroke-width"]), _createElementVNode("span", {
    "class": _normalizeClass(["tw-text-w-black tw-text-16 tw-hidden md:tw-block md:tw-pl-10px", {
      'active': _ctx.fullscreen
    }]),
    innerHTML: _ctx.labels.photo
  }, null, 10 /* CLASS, PROPS */, _hoisted_52)], 2 /* CLASS */)) : _createCommentVNode("v-if", true), _ctx.planimetries.length ? (_openBlock(), _createElementBlock("button", {
    key: 1,
    ref: "galleryPlanimetryBtn",
    "class": _normalizeClass(["modal-button tw-flex tw-items-center tw-text-10 tw-mb-5px tw-px-5px tw-mr-20px tw-justify-center tw-relative tw-pb-10px tw-bg-transparent", {
      'active': _ctx.planimetriesFullscreen
    }]),
    onClick: _cache[19] || (_cache[19] = _withModifiers(function ($event) {
      return _ctx.openPlanimetries(false);
    }, ["stop"]))
  }, [_createVNode(_component_plan_icon, {
    "stroke-width": _ctx.planimetriesFullscreen ? '1.5' : '1.2',
    width: 24,
    height: 24
  }, null, 8 /* PROPS */, ["stroke-width"]), _createElementVNode("span", {
    "class": _normalizeClass(["tw-text-w-black tw-text-16 tw-hidden md:tw-block md:tw-pl-10px", {
      'active': _ctx.planimetriesFullscreen
    }]),
    innerHTML: _ctx.labels.planimetry
  }, null, 10 /* CLASS, PROPS */, _hoisted_53)], 2 /* CLASS */)) : _createCommentVNode("v-if", true), _ctx.streetView ? (_openBlock(), _createElementBlock("button", {
    key: 2,
    ref: "galleryStreetviewBtn",
    "class": _normalizeClass(["modal-button tw-flex tw-items-center tw-text-10 tw-mb-5px tw-px-5px tw-mr-20px tw-justify-center tw-relative tw-pb-10px tw-bg-transparent", {
      'active': _ctx.streetViewFullscreen
    }]),
    onClick: _cache[20] || (_cache[20] = _withModifiers(function ($event) {
      return _ctx.openStreetView(false);
    }, ["stop"]))
  }, [_createVNode(_component_streetview_icon, {
    width: 24,
    height: 24
  }), _createElementVNode("span", {
    "class": _normalizeClass(["tw-text-w-black tw-text-16 tw-hidden md:tw-block md:tw-pl-10px", {
      'active': _ctx.streetViewFullscreen
    }]),
    innerHTML: _ctx.labels.streetview
  }, null, 10 /* CLASS, PROPS */, _hoisted_54)], 2 /* CLASS */)) : _createCommentVNode("v-if", true), _ctx.videoUrl ? (_openBlock(), _createElementBlock("button", {
    key: 3,
    ref: "galleryVideoBtn",
    "class": _normalizeClass(["modal-button tw-flex tw-items-center tw-text-10 tw-mb-5px tw-px-5px tw-mr-20px tw-justify-center tw-relative tw-pb-10px tw-bg-transparent", {
      'active': _ctx.videoFullscreen
    }]),
    onClick: _cache[21] || (_cache[21] = _withModifiers(function ($event) {
      return _ctx.openVideo(false);
    }, ["stop"]))
  }, [_createVNode(_component_video_icon, {
    "stroke-width": _ctx.videoFullscreen ? '1.5' : '1.2',
    height: 24,
    width: 24
  }, null, 8 /* PROPS */, ["stroke-width"]), _createElementVNode("span", {
    "class": _normalizeClass(["tw-text-w-black tw-text-16 tw-hidden md:tw-block md:tw-pl-10px", {
      'active': _ctx.videoFullscreen
    }]),
    innerHTML: _ctx.labels.video
  }, null, 10 /* CLASS, PROPS */, _hoisted_55)], 2 /* CLASS */)) : _createCommentVNode("v-if", true), _ctx.tourUrl ? (_openBlock(), _createElementBlock("button", {
    key: 4,
    ref: "galleryTourBtn",
    "class": _normalizeClass(["modal-button tw-flex tw-items-center tw-text-10 tw-mb-5px tw-px-5px tw-mr-20px tw-justify-center tw-relative tw-pb-10px tw-bg-transparent", {
      'active': _ctx.tourFullscreen
    }]),
    onClick: _cache[22] || (_cache[22] = _withModifiers(function ($event) {
      return _ctx.openTour(false);
    }, ["stop"]))
  }, [_createVNode(_component_tour_icon, {
    "stroke-width": _ctx.tourFullscreen ? '1.5' : '1.2',
    height: 24,
    width: 24
  }, null, 8 /* PROPS */, ["stroke-width"]), _createElementVNode("span", {
    "class": _normalizeClass(["tw-text-w-black tw-text-16 tw-hidden md:tw-block md:tw-pl-10px", {
      'active': _ctx.tourFullscreen
    }]),
    innerHTML: _ctx.labels.tour
  }, null, 10 /* CLASS, PROPS */, _hoisted_56)], 2 /* CLASS */)) : _createCommentVNode("v-if", true), _ctx.mapUrl ? (_openBlock(), _createElementBlock("button", {
    key: 5,
    ref: "galleryMapBtn",
    "class": _normalizeClass(["modal-button tw-flex tw-items-center tw-text-10 tw-mb-5px tw-px-5px tw-mr-20px tw-justify-center tw-relative tw-pb-10px tw-bg-transparent", {
      'active': _ctx.mapFullscreen
    }]),
    onClick: _cache[23] || (_cache[23] = _withModifiers(function ($event) {
      return _ctx.openMap(false);
    }, ["stop"]))
  }, [_createVNode(_component_map_icon, {
    width: 24,
    height: 24,
    "stroke-width": _ctx.mapFullscreen ? '1' : '0.8'
  }, null, 8 /* PROPS */, ["stroke-width"]), _createElementVNode("span", {
    "class": _normalizeClass(["tw-text-w-black tw-text-16 tw-hidden md:tw-block md:tw-pl-10px", {
      'active': _ctx.mapFullscreen
    }]),
    innerHTML: _ctx.labels.map
  }, null, 10 /* CLASS, PROPS */, _hoisted_57)], 2 /* CLASS */)) : _createCommentVNode("v-if", true)])])])) : _createCommentVNode("v-if", true)], 64 /* STABLE_FRAGMENT */);
}